import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';

import {DataFrameColumnDef, DataType, DeprecatedDataFrameColumnDef, IsMaskedDataRow} from './DataFrameTypes';

/**
 * @deprecated
 */
export const IS_MASKED_COLUMN_DEF: DeprecatedDataFrameColumnDef<IsMaskedDataRow> = {
  name: 'isMasked',
  type: DataType.BOOLEAN,
};

export const DATA_TYPE_TO_USER_FACING_NAME: {[key in DataType]: string} = {
  [DataType.BOOLEAN]: 'boolean',
  [DataType.DATE_OR_TIMESTAMP]: 'time series',
  [DataType.JSON]: 'json',
  [DataType.NUMBER]: 'numerical',
  [DataType.STRING]: 'text',
};

// Keep in sync with SystemColumnName in benchling/data_frames/column_definitions/system_columns.py
export const SYSTEM_COLUMN_PREFIX = 'benchcol_';

// Reserved prefix for internal, library-generated columns produced by benchling-dataframe-processing
// (e.g. the per-row id column `bnch__row_id`). Keep in sync with INTERNAL_COLUMN_SYSTEM_NAME_PREFIX +
// INTERNAL_COLUMN_SYSTEM_NAME_SEPARATOR in
// packages/benchling-dataframe-processing/src/benchling_dataframe_processing/columns/column_system_names.py.
// These columns are internal-only and must never be surfaced in the data frame viewer.
export const INTERNAL_COLUMN_PREFIX = 'bnch__';

/** Define columns and their system names assumed to present in every data frame.
 *
 * System columns as a concept is deprecated. Do not add additional system columns or use this enum in new code.
 *
 * @deprecated TODO(BNCH-62118): Remove system columns from the front-end.
 */
export enum SystemColumnName {
  IS_EXCLUDED = 'benchcol_is_excluded',
  ROW_ID = 'benchcol_row_id',
}

/** Define column def for SystemColumnName.IS_EXCLUDED
 *
 * System columns as a concept is deprecated. Do not use in new code.
 *
 * @deprecated TODO(BNCH-62118): Remove system columns from the front-end.
 */
export const IS_EXCLUDED_COLUMN_DEF: DataFrameColumnDef = {
  displayName: 'Is Excluded',
  systemName: SystemColumnName.IS_EXCLUDED,
  type: {leafType: LeafType.BOOLEAN},
};

/** Define column def for SystemColumnName.ROW_ID
 *
 * System columns as a concept is deprecated. Do not use in new code.
 *
 * @deprecated TODO(BNCH-62118): Remove system columns from the front-end.
 */
export const ROW_ID_COLUMN_DEF: DataFrameColumnDef = {
  displayName: 'Row ID',
  systemName: SystemColumnName.ROW_ID,
  type: {leafType: LeafType.TEXT},
};

/** Define map of SystemColumnName to their column defs.
 *
 * System columns as a concept is deprecated. Do not use in new code.
 *
 * @deprecated TODO(BNCH-62118): Remove system columns from the front-end.
 */
export const SYSTEM_COLUMN_DEFINITIONS: Record<SystemColumnName, DataFrameColumnDef> = {
  [SystemColumnName.IS_EXCLUDED]: IS_EXCLUDED_COLUMN_DEF,
  [SystemColumnName.ROW_ID]: ROW_ID_COLUMN_DEF,
};
